/**
 * PWK cart-cleanup. Hides the auto-rendered <span class="ajaxcart__product-meta">
 * Region/Phase entries for Performance Wax Kit line items in the drawer cart.
 *
 * The drawer cart is rendered client-side by the bundled theme JS (app.js),
 * which iterates over options_with_values and emits one span per option.
 * We can't intercept that bundle, so we observe the DOM and hide the spans
 * after they appear. PWK-only: detected by the product URL on the line-item.
 */
(function () {
  var PWK_HANDLE_PATTERN = /\/products\/performance-wax-kit/i;

  function hideForLineItem(lineItem) {
    var link = lineItem.querySelector('a[href*="/products/"]');
    if (!link || !PWK_HANDLE_PATTERN.test(link.getAttribute('href') || '')) return;
    var metas = lineItem.querySelectorAll('.ajaxcart__product-meta');
    for (var i = 0; i < metas.length; i++) {
      metas[i].style.display = 'none';
    }
    // Without the meta lines, the grey block hugs the title too tightly.
    // Restore breathing room by padding the .ajaxcart__product container.
    var container = lineItem.classList.contains('ajaxcart__product')
      ? lineItem
      : lineItem.closest('.ajaxcart__product');
    if (container && !container.dataset.pwkPadded) {
      container.style.padding = '16px';
      container.dataset.pwkPadded = '1';
    }
  }

  function sweep(root) {
    var lineItems = (root || document).querySelectorAll('[data-key], .ajaxcart__product, .cart__item, .ajaxcart [class*="item"]');
    for (var i = 0; i < lineItems.length; i++) {
      hideForLineItem(lineItems[i]);
    }
    // Fallback: scan all metas if no line-item containers were matched
    if (lineItems.length === 0) {
      var allMetas = (root || document).querySelectorAll('.ajaxcart__product-meta');
      for (var j = 0; j < allMetas.length; j++) {
        // Walk up to find a link, then test the handle
        var link = allMetas[j].closest('div, li, tr')?.querySelector('a[href*="/products/"]');
        if (link && PWK_HANDLE_PATTERN.test(link.getAttribute('href') || '')) {
          allMetas[j].style.display = 'none';
        }
      }
    }
  }

  function start() {
    sweep();
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType === 1) sweep(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
